import { OwcIcon, OwcProgressSpinner, OwcTypography } from '@one/react';
import type { PullToRefreshStatus } from 'common/hooks/pull-to-refresh/pull-to-refresh.business';
import { useTranslation } from 'core/i18n';
import { toIconRotation, toIndicatorOffset } from './pull-to-refresh-indicator.business';
import {
  PullToRefreshBubble,
  PullToRefreshIcon,
  PullToRefreshIndicatorLayout,
} from './pull-to-refresh-indicator.style';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  status: PullToRefreshStatus;
}

export const PullToRefreshIndicatorComponent: React.FC<PullToRefreshIndicatorProps> = ({
  pullDistance,
  status,
}) => {
  const { t } = useTranslation('common');

  if (status === 'idle') {
    return null;
  }

  return (
    <PullToRefreshIndicatorLayout>
      <PullToRefreshBubble $offset={toIndicatorOffset(pullDistance, status)} role="status">
        {status === 'refreshing' ? (
          <OwcProgressSpinner size="small" />
        ) : (
          <PullToRefreshIcon $rotation={toIconRotation(pullDistance)}>
            <OwcIcon name="refresh" family="outlined" />
          </PullToRefreshIcon>
        )}
        <OwcTypography variant="caption">{t(`components.pull-to-refresh.${status}`)}</OwcTypography>
      </PullToRefreshBubble>
    </PullToRefreshIndicatorLayout>
  );
};
